interface ImagePlaceholderProps {
    width: number
    height: number
    label?: string
    className?: string
    rounded?: 'none' | 'md' | 'lg' | 'full'
}

const roundedStyles = {
    none: '',
    md: 'rounded-md',
    lg: 'rounded-lg',
    full: 'rounded-full',
}

export function ImagePlaceholder({
    width,
    height,
    label,
    className = '',
    rounded = 'lg',
}: ImagePlaceholderProps) {
    return (
        <div
            className={`
        relative bg-gradient-to-br from-gray-200 to-gray-300
        flex flex-col items-center justify-center
        ${roundedStyles[rounded]}
        ${className}
      `}
            style={{
                width: '100%',
                aspectRatio: `${width}/${height}`,
                maxWidth: `${width}px`,
            }}
        >
            <svg
                className="w-12 h-12 text-gray-400 mb-2"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
            >
                <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={1.5}
                    d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z"
                />
            </svg>
            <span className="text-xs text-gray-500 font-medium">
                {label || `${width}x${height}px`}
            </span>
        </div>
    )
}
